<template>
  <el-select
    :value="value"
    size="small"
    filterable
    clearable
    @change="handleChange"
    :loading="loading"
    placeholder="请选择"
    style="width: 100%"
    :popper-append-to-body="true"
  >
    <el-option v-for="item in lists" :key="item" :label="item" :value="item">
    </el-option>
  </el-select>
</template>

<script>
import { deviceCraftPostList } from '@/service/getData'

export default {
  props: {
    value: '',
    application: Array,
  },
  data() {
    return {
      lists: [],
      loading: false,
    }
  },
  watch: {
    application: 'requestData',
  },
  created() {
    this.requestData()
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
    async requestData() {
      if (this.application.length == 0) {
        this.lists = []
        return
      }

      this.loading = true
      let data = {
        application: this.application,
        size: 1,
      }

      let res = await deviceCraftPostList(data)
      this.loading = false
      this.lists = res.data.total ? res.data.list[0].crafts : []
    },
  },
}
</script>